import { IMucphaiThuInsert } from "../models/response/finance/IMucPhaiThu";
import { apiClient } from "./apiClient";

export const mucpPhaiThuApi={
    selectByHocSinh : (ts_hocsinh_id:number, nam_hoc:string) => apiClient.get(`sf_mucphaithu/ts_hocsinh_id/${ts_hocsinh_id}/nam_hoc/${nam_hoc}`),
    save_ghi_danh : (request:IMucphaiThuInsert) => apiClient.post(`sf_mucphaithu/ghi_danh/`, request),
}